import { TextSmall } from '@/components/Texts';
import React from 'react';

const NoObligationProvidePersonalData = () => {
  return (
    <>
      <TextSmall fontWeight={700}>
        (10) No obligation to provide personal data
      </TextSmall>
      <TextSmall>
        We do not make the conclusion of contracts with us dependent on you
        providing us with personal data in advance. As a customer, you are under
        no legal or contractual obligation to provide us with your personal
        data; however, we may only be able to provide certain services to a
        limited extent or not at all if you do not provide the necessary data.
        If this should exceptionally be the case in the context of the products
        we offer presented below, you will be informed of this separately.
      </TextSmall>
    </>
  );
};

export default NoObligationProvidePersonalData;
